import { AppRootState } from 'app/store'

export const selectCurrentTask = (state: AppRootState) => state.simulator.task
export const selectResultsByLines = (state: AppRootState) => state.simulator.resultsByLines
export const selectTimerStatus = (state: AppRootState) => state.simulator.timerStatus
export const selectIsCompleted = (state: AppRootState) => state.simulator.isCompleted
